import clsx from 'clsx';
import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { scrollBodyPopup } from '@/common/client';
import { motionOpacityVariant } from 'nike-ui/src/common/util';

function useDisabledScrollBehindPopup() {
    useEffect(() => {
        scrollBodyPopup(false);
        return () => scrollBodyPopup(true);
    }, []);
}

export function Popup({ className, children, onClose }) {
    useDisabledScrollBehindPopup();

    function handleOnClick() {
        setTimeout(() => {
            onClose();
        }, 0.3);
    }

    return (
        <>
            <AnimatePresence>
                <motion.div
                    key="backdrop"
                    variants={motionOpacityVariant}
                    initial="initial"
                    animate="enter"
                    exit="exit"
                    className="ui-popup-screen in"
                />
            </AnimatePresence>
            <div className="ui-popup-wrap">
                <div className="ui-popup-close" onClick={handleOnClick} />
                <div className="ui-popup-container">
                    <div className={clsx('ui-popup', className)}>
                        <div className="message">
                            <span className="text-left">{children}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
